<!-- <img *ngIf="loading" height="30px" src="assets/images/Spin.gif" alt="loading" /> -->
<!-- <img [hidden]="loading" (load)="onLoad()" [src]='logoUrl' class="img-responsive" (click)="clickInLogo()" style="cursor: pointer; padding: 0px; max-height: 50px; max-width: 110px;" alt="Logo"> -->

<!-- current useable logo -->
<!-- <img [src]='logoUrl' class="img-responsive" (click)="clickInLogo()" style="cursor: pointer; padding: 0px; max-height: 50px; max-width: 110px;" alt="Logo"> -->



<a class="navbar-brand"><img [src]="logoUrl" style="width: 150px; height: 40px;" class="img-responsive"
    (click)="clickInLogo()" alt="Catalyzr Logo" class="img-responsive"></a>